<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="linha alinha-v">
          <div class="m-icone esquerda"><a @click="$router.back()" style="cursor: pointer" class="icone-voltar m-d"></a>
          </div>
          <h2>Check List de Acesso – Roboflex</h2>
        </div>
      </div>
    </div>
    <div class="margem container">
      <div v-if="!permissoes.includes(256)" class="bloco margem card-dados-restrito">
        <h3 class="status-titulo">Resumo da visita</h3>
        <dl class="lista-dados-restrita">
          <dt>Anfitrião(ã)</dt>
          <dd>{{ resumoVisitaRestrita.nomeAnfitriao || "—" }}</dd>
          <dt>Visitante</dt>
          <dd>{{ visitante.nome || "—" }}</dd>
          <dt>Empresa</dt>
          <dd>{{ visitante.empresa || "—" }}</dd>
          <dt>Status do agendamento</dt>
          <dd>{{ textoStatusResumo() }}</dd>
        </dl>
        <button type="button" class="btn-acao-visita btn-secundario" @click="$router.back()">
          <i class="fa-solid fa-arrow-left"></i> Voltar
        </button>
      </div>
      <template v-else>
      <div class="bloco margem card-visitante">
        <div class="card-visitante-inner">
          <div class="card-visitante-icone">
            <i :class="visitante.ehGrupo ? 'fa-solid fa-people-group' : 'fa-solid fa-user'"></i>
          </div>
          <div class="card-visitante-dados">
            <div v-if="visitante.totalVisitantesNaSolicitacao > 1" class="badge-grupo fonte-menor">
              Visita em grupo — {{ visitante.totalVisitantesNaSolicitacao }} pessoa(s); esta tela é para
              <strong>{{ visitante.nome || "—" }}</strong>
            </div>
            <div v-else-if="visitante.ehGrupo" class="badge-grupo">Visita em grupo ({{ visitante.quantidade }} pessoa(s))
            </div>
            <div class="nome">{{ visitante.nome || "—" }}</div>
            <div class="linha empresa-origem-linha">
              <template v-if="!editandoEmpresaOrigem">
                <span>Empresa: {{ visitante.empresa || "—" }}</span>
                <button
                  v-if="podeEditarEmpresaOrigem"
                  type="button"
                  class="btn-link-acao btn-alterar-empresa"
                  @click="iniciarEdicaoEmpresaOrigem"
                >
                  <i class="fa-solid fa-pen-to-square"></i> Alterar
                </button>
              </template>
              <div v-else class="campo-grupo empresa-edit">
                <label for="inp-empresa-origem-checklist">Empresa de origem</label>
                <input
                  id="inp-empresa-origem-checklist"
                  v-model.trim="empresaOrigemRascunho"
                  type="text"
                  maxlength="250"
                  placeholder="Nome da empresa do visitante"
                />
                <div class="empresa-edit-acoes">
                  <button
                    type="button"
                    class="btn-acao-visita btn-secundario"
                    :disabled="salvandoEmpresaOrigem"
                    @click="cancelarEdicaoEmpresaOrigem"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn-acao-visita btn-principal"
                    :disabled="salvandoEmpresaOrigem"
                    @click="salvarEmpresaOrigem"
                  >
                    <i v-if="salvandoEmpresaOrigem" class="fas fa-spinner fa-spin"></i>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
            <div class="linha">Data/Hora planejada: {{ formatarDataHora(visitante.dataHoraPlanejada) }}</div>
            <div class="linha">Data/Hora real: {{ formatarDataHora(visitante.dataHoraReal) }}</div>
            <div class="linha">Horários efetivos (check-in / check-out): {{ textoHorariosEfetivos() }}</div>
            <div v-if="visitaFinalizada && visitante.checkoutRegistradoPorNome" class="linha">
              Check-out registrado por: {{ visitante.checkoutRegistradoPorNome }}
            </div>
          </div>
          <div class="card-visitante-acoes">
            <router-link v-if="idVisita" :to="'/acesso/visita/' + idVisita + '/historico'" class="btn-acao">
              <i class="fa-solid fa-magnifying-glass"></i> Histórico de visitas </router-link>
            <router-link v-if="idVisita" :to="'/acesso/visita/' + idVisita + '/dados-completos'" class="btn-acao">
              <i class="fa-solid fa-user"></i> Dados completos do visitante </router-link>
            <router-link v-if="idVisita" :to="'/acesso/visita/' + idVisita + '/dados-completos-visita'"
              class="btn-acao">
              <i class="fa-solid fa-calendar-check"></i> Dados completos da visita </router-link>
          </div>
        </div>
      </div>
      <!-- Status da visita (timeline 4 etapas) -->
      <div class="bloco margem status-visita">
        <h3 class="status-titulo">Status da visita</h3>
        <div class="timeline-visita">
          <div v-for="(etapa, idx) in etapasVisita" :key="idx" class="timeline-etapa"
            :class="{ concluido: statusTimeline > idx + 1, atual: statusTimeline === idx + 1 }">
            <span class="etapa-marker">
              <i v-if="statusTimeline > idx + 1" class="fa-solid fa-check"></i>
              <i v-else class="etapa-icone" :class="etapa.icone"></i>
            </span>
            <span class="etapa-label">{{ etapa.label }}</span>
            <span v-if="idx < etapasVisita.length - 1" class="etapa-seta"></span>
          </div>
        </div>
      </div>
      <!-- QR Code: edição até o check-out; após visita encerrada, exibe o código usado (persistido no servidor) -->
      <div v-if="idVisita" class="bloco margem secao-qrcode" :class="{ 'secao-qrcode-leitura': visitaFinalizada }">
        <h3 class="status-titulo"><i class="fa-solid fa-qrcode"></i> QR Code para acesso à empresa</h3>
        <p v-if="visitaFinalizada" class="fonte-menor fonte-fraca m-b">Código utilizado durante a visita (registrado ao confirmar a saída).</p>
        <div v-for="row in linhasQrVisitantes" :key="row.key" class="bloco margem linha"
          style="align-items: center; gap: 1rem; padding: 0.75rem 1rem; border-radius: 6px; border: 1px solid var(--cor-separador);">
          <div class="nome-visitante-qr" style="min-width: 180px;">
            <i class="fa-solid fa-user"></i> {{ row.nome }}
          </div>
          <template v-if="row.qr">
            <div class="linha primaria-fraca" style="align-items: center; gap: 0.5rem; padding: 0.35rem 0.75rem; border-radius: 6px;">
              <i class="fa-solid fa-link"></i>
              <span><strong>{{ row.qr.codigo }}</strong></span>
              <span v-if="row.qr.descricao" class="fonte-menor">— {{ row.qr.descricao }}</span>
            </div>
            <button
              v-if="!visitaFinalizada && vinculacaoAtivaVisitanteAtual"
              type="button"
              class="btn-acao-visita btn-secundario"
              :disabled="enviandoQrPorVisitante[visitanteIndexChecklist]"
              @click="desvincularQrCodeAtual"
            >
              <i v-if="enviandoQrPorVisitante[visitanteIndexChecklist]" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fa-solid fa-link-slash"></i> Desvincular
            </button>
          </template>
          <div v-else-if="!visitaFinalizada" class="linha" style="flex-wrap: wrap; align-items: center; gap: 0.5rem;">
            <p
              v-if="avisoQrIndisponivel"
              class="fonte-menor fonte-fraca"
              style="flex: 1 1 100%; margin: 0;"
            >
              {{ avisoQrIndisponivel }}
            </p>
            <select
              :id="'select-qrcode-' + visitanteIndexChecklist"
              v-model="qrCodeSelecionadoPorVisitante[visitanteIndexChecklist]"
              :disabled="enviandoQrPorVisitante[visitanteIndexChecklist]"
              class="select-qr-visitante"
            >
              <option :value="null">Selecione um código</option>
              <option
                v-for="opt in qrOpcoesSelect"
                :key="opt.qr.id"
                :value="opt.qr.id"
                :disabled="!opt.disponivel"
              >{{ rotuloQrFixo(opt.qr) }}{{ opt.emUso ? " (em uso)" : "" }}</option>
            </select>
            <button
              type="button"
              class="btn-acao-visita btn-principal"
              :disabled="!qrCodeSelecionadoPorVisitante[visitanteIndexChecklist] || enviandoQrPorVisitante[visitanteIndexChecklist]"
              @click="vincularQrCodeAtual"
            >
              <i v-if="enviandoQrPorVisitante[visitanteIndexChecklist]" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fa-solid fa-link"></i> Vincular
            </button>
          </div>
          <div v-else class="fonte-menor fonte-fraca">Nenhum QR vinculado nesta visita.</div>
        </div>
      </div>
      <!-- Entrada e Saída: visual e texto conforme o status -->
      <div class="grid-checklist">
        <!-- ENTRADA (check-in) -->
        <div class="bloco margem col-checklist col-entrada"
          :class="checkinRealizado ? 'estado-concluido' : 'estado-acao'">
          <div class="aba-titulo" :class="checkinRealizado ? 'aba-concluido' : 'aba-entrada'">
            <i :class="checkinRealizado ? 'fa-solid fa-circle-check' : 'fa-solid fa-right-to-bracket'"></i> {{
              tituloColunaEntrada }}
          </div>
          <div class="checklist-body">
            <label v-for="(item, idx) in itensCheckin" :key="'ci-' + idx" class="item-checklist">
              <input
                type="checkbox"
                :checked="checkboxCheckinMarcado(item.id)"
                :disabled="checkinRealizado"
                @change="onToggleCheckin(item.id, $event)"
              />
              {{ item.label }}
            </label>
            <div class="campo-obs">
              <label>Observações da entrada:</label>
              <textarea v-model="obsCheckin" rows="3" placeholder="Observações" :disabled="checkinRealizado"></textarea>
            </div>
            <div
              v-if="!checkinRealizado && !checkinCompleto && pendenciasCheckin.length"
              class="pendencias-checkin bloco margem"
              role="status"
            >
              <strong class="fonte-menor">Para liberar «Registrar entrada»:</strong>
              <ul class="fonte-menor pendencias-lista">
                <li v-for="(txt, pi) in pendenciasCheckin" :key="'pend-' + pi">{{ txt }}</li>
              </ul>
            </div>
            <button type="button" class="btn-acao-visita" :class="classeBotaoEntrada"
              :disabled="checkinRealizado || !checkinCompleto || enviandoCheckin" @click="confirmarCheckin">
              <i v-if="enviandoCheckin" class="fas fa-spinner fa-spin"></i>
              <i v-else-if="checkinRealizado" class="fa-solid fa-check"></i>
              <i v-else class="fa-solid fa-right-to-bracket"></i> {{ textoBotaoCheckin }} </button>
          </div>
        </div>
        <!-- SAÍDA (check-out) -->
        <div class="bloco margem col-checklist col-saida" :class="classeColunaSaida">
          <div class="aba-titulo" :class="classeAbaSaida">
            <i :class="iconeColunaSaida"></i> {{ tituloColunaSaida }}
          </div>
          <p v-if="!checkinRealizado && !visitaFinalizada" class="aviso-aguarde">
            <i class="fa-solid fa-clock"></i> Registre a entrada do visitante primeiro para liberar o registro de saída.
          </p>
          <div class="checklist-body">
            <label v-for="(item, idx) in itensCheckout" :key="'co-' + idx" class="item-checklist">
              <input
                type="checkbox"
                :checked="checkboxCheckoutMarcado(item.id)"
                :disabled="!checkinRealizado || visitaFinalizada"
                @change="onToggleCheckout(item.id, $event)"
              />
              {{ item.label }}
            </label>
            <div class="campo-obs">
              <label>Observações da saída:</label>
              <textarea v-model="obsCheckout" rows="3" placeholder="Observações"
                :disabled="!checkinRealizado || visitaFinalizada"></textarea>
            </div>
            <div v-if="checkinRealizado && !visitaFinalizada" class="campo-grupo checkout-auto">
              <label>Responsável pelo check-out</label>
              <p class="fonte-menor checkout-auto-txt">
                {{ nomeUsuarioLogadoCheckout }}
                <span class="fonte-fraca"> — data e hora serão registradas automaticamente no servidor ao confirmar a saída.</span>
              </p>
            </div>
            <button type="button" class="btn-acao-visita" :class="classeBotaoSaida"
              :disabled="!checkinRealizado || visitaFinalizada || !checkoutCompleto || enviandoCheckout"
              @click="finalizarCheckout">
              <i v-if="enviandoCheckout" class="fas fa-spinner fa-spin"></i>
              <i v-else-if="visitaFinalizada" class="fa-solid fa-check"></i>
              <i v-else-if="!checkinRealizado" class="fa-solid fa-lock"></i>
              <i v-else class="fa-solid fa-right-from-bracket"></i> {{ textoBotaoCheckout }} </button>
          </div>
        </div>
      </div>
      </template>
    </div>
  </section>
</template>
<script>
import { createToaster } from "@meforma/vue-toaster";
import checklistAcessoService, {
  checkinRealizadoParaVisitante,
  visitaFinalizadaParaVisitante,
  qrVinculadoAtivoParaVisitante,
  montarListaVisitantesSolicitacao,
  linhaVisitantePorIndex,
} from "@/services/checklist-acesso-service";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import { sso } from "roboflex-thalamus-sso-lib";
import { isDataVisitaEstritamentePassada } from "@/utils/visita-data";
import { getPermissao } from "@/services/permissaoService";
import { textoStatus as textoStatusConfig } from "@/config/status-visita";
import {
  dadosCadastraisVisitanteOkParaCheckin,
  pendenciasCadastroVisitanteParaCheckin,
  visitanteNaLinhaDoCheckin,
} from "@/config/visitante-checkin-obrigatorio";
import {
  contarQrNoPool,
  qrCodesDisponiveisParaVisita,
  qrOpcoesPoolParaSelect,
  rotuloQrFixo,
} from "@/utils/qr-codes-fixos";

const toaster = createToaster({ position: "top-right" });

const ETAPAS_VISITA = [
  { label: "Solicitação", icone: "fa-solid fa-file-lines" },
  { label: "Check-in", icone: "fa-solid fa-right-to-bracket" },
  { label: "Acompanhamento", icone: "fa-solid fa-people-group" },
  { label: "Check-out", icone: "fa-solid fa-right-from-bracket" },
];

const ITENS_CHECKIN = [
  { id: "doc_validado", label: "Documento validado / Informações conferidas" },
  { id: "crachá_entregue", label: "Crachá de visitante entregue" },
  { id: "orientacoes_seguranca", label: "Orientações de segurança apresentadas" },
  { id: "epis_entregues", label: "EPIs entregues (óculos / protetor auricular)" },
  { id: "acompanhamento_confirmado", label: "Acompanhamento obrigatório do anfitrião(ã) confirmado" },
];

const ITENS_CHECKOUT = [
  { id: "devolucao_epis", label: "Devolução dos EPIs" },
  { id: "confirmacao_acompanhamento", label: "Confirmação de acompanhamento do anfitrião(ã)" },
  { id: "devolucao_cracha", label: "Devolução do crachá e crachá na recepção" },
  { id: "devolucao_qrcode", label: "QR code de acesso devolvido (desvinculado no sistema no check-out)" },
];

function estadoInicialCheckin() {
  return ITENS_CHECKIN.reduce((acc, i) => ({ ...acc, [i.id]: false }), {});
}

function estadoInicialCheckout() {
  return ITENS_CHECKOUT.reduce((acc, i) => ({ ...acc, [i.id]: false }), {});
}

export default {
  name: "CheckListAcessoView",

  data() {
    return {
      permissoes: [],
      visitante: {},
      resumoVisitaRestrita: {
        nomeAnfitriao: "",
        statusAgendamento: null,
      },
      statusVisita: 4,
      etapasVisita: ETAPAS_VISITA,
      itensCheckin: ITENS_CHECKIN,
      itensCheckout: ITENS_CHECKOUT,
      checkin: estadoInicialCheckin(),
      checkout: estadoInicialCheckout(),
      obsCheckin: "",
      obsCheckout: "",
      enviandoCheckin: false,
      enviandoCheckout: false,
      qrCodesFixos: [],
      listaVisitantesDaVisita: [],
      vinculacoesPorVisitante: {},
      /** Após check-out, API limpa vínculos ativos; snapshot vem em `qrcodes_usados_visitantes`. */
      qrcodesUsadosPorVisitante: {},
      qrCodeSelecionadoPorVisitante: {},
      enviandoQrPorVisitante: {},
      visitaCancelada: false,
      editandoEmpresaOrigem: false,
      empresaOrigemRascunho: "",
      salvandoEmpresaOrigem: false,
      flagsTipoVisita: {
        tipoPrestadorServico: false,
        tipo_prestador_servico: false,
      },
    };
  },

  computed: {
    flagsVisitaQr() {
      return {
        tipoPrestadorServico: Boolean(
          this.flagsTipoVisita.tipoPrestadorServico ?? this.flagsTipoVisita.tipo_prestador_servico
        ),
        tipo_prestador_servico: Boolean(
          this.flagsTipoVisita.tipo_prestador_servico ?? this.flagsTipoVisita.tipoPrestadorServico
        ),
      };
    },
    qrOpcoesSelect() {
      if (!this.idVisita) return [];
      return qrOpcoesPoolParaSelect({
        lista: this.qrCodesFixos,
        visitaId: this.idVisita,
        visitanteIndex: this.visitanteIndexChecklist,
        flagsVisita: this.flagsVisitaQr,
      });
    },

    avisoQrIndisponivel() {
      if (!this.idVisita || this.visitaFinalizada) return "";
      const disp = this.qrCodesDisponiveisPara(this.visitanteIndexChecklist);
      if (disp.length > 0) return "";
      if (this.qrOpcoesSelect.length > 0) {
        return "Todos os QR codes deste pool estão em uso em outras visitas em andamento. Finalize o check-out na visita que utiliza o cartão ou escolha outro número.";
      }
      const totalApi = Array.isArray(this.qrCodesFixos) ? this.qrCodesFixos.length : 0;
      if (totalApi === 0) {
        return "Nenhum QR code cadastrado no sistema. Peça ao administrador para cadastrar os cartões Visitante 1–5 e Prestador 1–10.";
      }
      const noPool = contarQrNoPool(this.qrCodesFixos, this.flagsVisitaQr);
      if (noPool === 0) {
        return "Nenhum cartão QR reconhecido. Os códigos devem ser Visitante 1–5 ou Prestador de serviço 1–10 (ex.: V001, P001).";
      }
      return "Todos os QR codes estão em uso em outras visitas. Desvincule ou finalize a visita que os utiliza.";
    },
    statusTimeline() {
      if (this.visitaFinalizada) return 4;
      if (this.checkinRealizado) return 3;
      if (this.statusVisita >= 4) return 2;
      return 1;
    },

    estadoVisitanteChecklist() {
      return {
        visitanteIndex: this.visitanteIndexChecklist,
        checkinEm: this.visitante.checkinEm,
        checkoutEm: this.visitante.checkoutEm,
        listaVisitantes: this.listaVisitantesDaVisita,
        vinculacoesPorVisitante: this.vinculacoesPorVisitante,
        qrcodesUsadosPorVisitante: this.qrcodesUsadosPorVisitante,
      };
    },

    /** Vínculo ativo (obrigatório antes do check-in; snapshot `qrcodes_usados` não conta). */
    qrVinculadoAtual() {
      return qrVinculadoAtivoParaVisitante(this.vinculacoesPorVisitante, this.visitanteIndexChecklist);
    },

    vinculacaoAtivaVisitanteAtual() {
      return qrVinculadoAtivoParaVisitante(this.vinculacoesPorVisitante, this.visitanteIndexChecklist);
    },

    idVisita() {
      return this.$route.params.id || null;
    },

    visitanteIndexChecklist() {
      const q = this.$route.query.vi;
      const n = q != null && q !== "" ? parseInt(String(q), 10) : 0;
      return Number.isFinite(n) && n >= 0 ? n : 0;
    },

    podeEditarEmpresaOrigem() {
      if (!this.idVisita) return false;
      if (this.visitaCancelada) return false;
      const raw = this.visitante?.dataHoraPlanejada;
      if (raw == null || String(raw).trim() === "") return true;
      return !isDataVisitaEstritamentePassada(String(raw), this.visitante?.dataVisitaFim ?? this.visitante?.data_visita_fim);
    },

    /** Paridade com o fluxo de check-in do app mobile (ChecklistScreen). */
    visitanteCadastroLinha() {
      return visitanteNaLinhaDoCheckin(this.listaVisitantesDaVisita, this.visitanteIndexChecklist);
    },

    dadosCadastraisOkParaCheckin() {
      if (this.checkinRealizado) return true;
      return dadosCadastraisVisitanteOkParaCheckin(this.visitanteCadastroLinha);
    },

    faltasCadastroCheckin() {
      return pendenciasCadastroVisitanteParaCheckin(this.visitanteCadastroLinha);
    },

    checkinCompleto() {
      const itensOk = this.dadosCadastraisOkParaCheckin && ITENS_CHECKIN.every((i) => this.checkin[i.id]);
      if (!itensOk) return false;
      if (this.checkinRealizado) return true;
      return !!this.qrVinculadoAtual;
    },

    pendenciasCheckin() {
      if (this.checkinRealizado) return [];
      const p = [];
      if (!this.dadosCadastraisOkParaCheckin && this.faltasCadastroCheckin.length > 0) {
        p.push(
          `Complete o cadastro do visitante (faltam: ${this.faltasCadastroCheckin.join(", ")}). Use «Completar cadastro» — o que você já preencheu nesta tela permanece.`
        );
      }
      const faltamItens = ITENS_CHECKIN.filter((i) => !this.checkin[i.id]);
      if (faltamItens.length > 0) {
        p.push(
          faltamItens.length === 1
            ? `Marque o item: ${faltamItens[0].label}`
            : `Faltam ${faltamItens.length} itens da lista de entrada — marque todos.`
        );
      }
      if (!this.qrVinculadoAtual) {
        p.push("Vincule um QR code de acesso a este visitante (seção acima).");
      }
      return p;
    },

    checkoutCompleto() {
      if (this.visitaFinalizada) return true;
      return ITENS_CHECKOUT.every((i) => this.checkout[i.id]);
    },

    /** Check-in deste visitante (índice `?vi=`), não status global da visita em grupo. */
    checkinRealizado() {
      return checkinRealizadoParaVisitante(this.estadoVisitanteChecklist);
    },

    /** Check-out deste visitante. */
    visitaFinalizada() {
      return visitaFinalizadaParaVisitante(this.estadoVisitanteChecklist);
    },

    textoBotaoCheckin() {
      if (this.checkinRealizado) return "Entrada registrada";
      if (this.enviandoCheckin) return "Salvando...";
      return "Registrar entrada";
    },

    textoBotaoCheckout() {
      if (this.visitaFinalizada) return "Visita finalizada";
      if (!this.checkinRealizado) return "Realize a entrada primeiro";
      if (this.enviandoCheckout) return "Salvando...";
      return "Registrar saída";
    },

    tituloColunaEntrada() {
      return this.checkinRealizado ? "Entrada registrada" : "Registrar entrada do visitante";
    },

    tituloColunaSaida() {
      if (this.visitaFinalizada) return "Saída registrada";
      if (!this.checkinRealizado) return "Aguardando entrada";
      return "Registrar saída do visitante";
    },

    iconeColunaSaida() {
      if (this.visitaFinalizada) return "fa-solid fa-circle-check";
      if (!this.checkinRealizado) return "fa-solid fa-lock";
      return "fa-solid fa-right-from-bracket";
    },

    classeColunaSaida() {
      if (this.visitaFinalizada) return "estado-concluido";
      if (!this.checkinRealizado) return "estado-bloqueado";
      return "estado-acao";
    },

    classeAbaSaida() {
      if (this.visitaFinalizada) return "aba-concluido";
      if (!this.checkinRealizado) return "aba-bloqueado";
      return "aba-saida";
    },

    classeBotaoEntrada() {
      if (this.checkinRealizado) return "btn-concluido";
      if (this.checkinCompleto && !this.enviandoCheckin) return "btn-principal";
      return "btn-secundario";
    },

    classeBotaoSaida() {
      if (this.visitaFinalizada) return "btn-concluido";
      if (!this.checkinRealizado) return "btn-bloqueado";
      if (this.checkoutCompleto && !this.enviandoCheckout) return "btn-principal";
      return "btn-secundario";
    },

    nomeUsuarioLogadoCheckout() {
      const u = sso.getUsuarioLogado?.() ?? {};
      const n = String(u.nome ?? u.name ?? "").trim();
      return n || "Usuário logado";
    },

    /** Uma linha QR: somente o visitante aberto nesta tela (`visitanteIndexChecklist`). */
    linhasQrVisitantes() {
      const iv = this.visitanteIndexChecklist;
      const lista = this.listaVisitantesDaVisita || [];
      const pessoa =
        linhaVisitantePorIndex(lista, iv) ||
        lista.find((p, idx) => this.indiceVisitante(p, idx) === iv) ||
        null;
      const nome =
        pessoa?.nome_completo ||
        pessoa?.nomeCompleto ||
        this.visitante.nome ||
        `Visitante ${iv + 1}`;
      return [
        {
          key: iv,
          iv,
          nome,
          qr: this.qrExibicaoVisitante(iv),
        },
      ];
    },

  },

  watch: {
    visitanteIndexChecklist() {
      this.editandoEmpresaOrigem = false;
      this.carregarVisita();
    },
  },

  async created() {
    this.permissoes = await getPermissao();
    this.carregarVisita();
  },

  methods: {
    textoStatusResumo() {
      const s = this.resumoVisitaRestrita.statusAgendamento ?? this.statusVisita;
      return textoStatusConfig(s, this.visitaCancelada);
    },

    indiceVisitante(pessoa, loopIdx) {
      const x = pessoa?.index ?? pessoa?.visitante_index;
      if (x != null && x !== "" && !Number.isNaN(Number(x))) return Number(x);
      return loopIdx;
    },

    checkboxCheckinMarcado(id) {
      return this.checkinRealizado || !!this.checkin[id];
    },

    onToggleCheckin(id, ev) {
      if (this.checkinRealizado) return;
      const checked = !!(ev?.target && ev.target.checked);
      this.checkin = { ...this.checkin, [id]: checked };
    },

    checkboxCheckoutMarcado(id) {
      return this.visitaFinalizada || !!this.checkout[id];
    },

    onToggleCheckout(id, ev) {
      if (!this.checkinRealizado || this.visitaFinalizada) return;
      const checked = !!(ev?.target && ev.target.checked);
      this.checkout = { ...this.checkout, [id]: checked };
    },

    iniciarEdicaoEmpresaOrigem() {
      if (!this.podeEditarEmpresaOrigem) return;
      this.empresaOrigemRascunho = String(this.visitante.empresa || "").trim();
      this.editandoEmpresaOrigem = true;
    },

    cancelarEdicaoEmpresaOrigem() {
      this.editandoEmpresaOrigem = false;
      this.empresaOrigemRascunho = "";
    },

    async salvarEmpresaOrigem() {
      if (!this.idVisita || this.salvandoEmpresaOrigem) return;
      this.salvandoEmpresaOrigem = true;
      try {
        await solicitacaoVisitaService.atualizarEmpresaOrigem(this.idVisita, this.empresaOrigemRascunho);
        const novo = String(this.empresaOrigemRascunho || "").trim();
        this.visitante = { ...this.visitante, empresa: novo || "—" };
        this.editandoEmpresaOrigem = false;
        this.empresaOrigemRascunho = "";
        toaster.show("Empresa atualizada.", { type: "success" });
      } catch (err) {
        console.error(err);
        const msg = err?.response?.data?.message || "Não foi possível salvar a empresa.";
        toaster.show(typeof msg === "string" ? msg : "Erro ao salvar.", { type: "error" });
      } finally {
        this.salvandoEmpresaOrigem = false;
      }
    },

    /** Vínculo ativo ou, após check-out, snapshot `qrcode_usado` gravado no servidor. */
    qrExibicaoVisitante(visitanteIndex) {
      const idx = Number(visitanteIndex);
      return this.vinculacoesPorVisitante[idx] || this.qrcodesUsadosPorVisitante[idx] || null;
    },

    rotuloQrFixo(qr) {
      return rotuloQrFixo(qr);
    },

    /** QR do pool da visita (visitante 1–5 ou prestador 1–10), livres ou já vinculados a esta pessoa */
    qrCodesDisponiveisPara(visitanteIndex) {
      const id = this.idVisita;
      if (!id) return [];
      return qrCodesDisponiveisParaVisita({
        lista: this.qrCodesFixos,
        visitaId: id,
        visitanteIndex: Number(visitanteIndex),
        flagsVisita: this.flagsVisitaQr,
      });
    },

    aplicarFlagsTipoVisita(origem) {
      if (!origem || typeof origem !== "object") return;
      this.flagsTipoVisita = {
        tipoPrestadorServico: Boolean(origem.tipo_prestador_servico ?? origem.tipoPrestadorServico),
        tipo_prestador_servico: Boolean(origem.tipo_prestador_servico ?? origem.tipoPrestadorServico),
      };
    },

    formatarDataHora(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return "—";
      return d.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    horaLocalDeIso(val) {
      if (!val) return "";
      const d = new Date(val);
      if (isNaN(d.getTime())) return "";
      return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", hour12: false });
    },

    textoHorariosEfetivos() {
      const e = this.horaLocalDeIso(this.visitante?.checkinEm);
      const s = this.horaLocalDeIso(this.visitante?.checkoutEm);
      if (!e && !s) return "—";
      return `${e || "—"} / ${s || "—"}`;
    },

    async carregarVisita() {
      if (!this.idVisita) {
        this.visitaCancelada = false;
        this.editandoEmpresaOrigem = false;
        this.visitante = {
          nome: "Fulano de tal",
          empresa: "XXXXXX",
          empresaVisitada: "Beltrana LTDA",
          ehGrupo: false,
          quantidade: 1,
          totalVisitantesNaSolicitacao: 1,
        };
        this.statusVisita = 4;
        return;
      }
      try {
        this.visitaCancelada = false;
        this.qrcodesUsadosPorVisitante = {};
        const [visita, solFlags] = await Promise.all([
          checklistAcessoService.obterVisita(this.idVisita, this.visitanteIndexChecklist),
          solicitacaoVisitaService.obterPorId(this.idVisita).catch(() => null),
        ]);
        if (solFlags) {
          this.resumoVisitaRestrita = {
            nomeAnfitriao: solFlags.nomeAnfitriao || "",
            statusAgendamento: solFlags.statusAgendamento ?? null,
          };
        }
        if (visita) {
          const temTipoNaVisita =
            visita.tipo_prestador_servico !== undefined || visita.tipoPrestadorServico !== undefined;
          this.aplicarFlagsTipoVisita(temTipoNaVisita ? visita : solFlags || visita);
          const totalNaSol =
            visita.total_visitantes_na_solicitacao ?? visita.totalVisitantesNaSolicitacao ?? visita.quantidade_visitantes ?? 1;
          const listaApi =
            Array.isArray(visita.lista_visitantes) && visita.lista_visitantes.length > 0
              ? visita.lista_visitantes
              : [];
          const linhaAtual = linhaVisitantePorIndex(listaApi, this.visitanteIndexChecklist);
          this.visitante = {
            nome: visita.nome_completo ?? visita.nomeCompleto ?? visita.nome,
            empresa: visita.empresa_origem ?? visita.empresaOrigem ?? visita.empresa,
            empresaVisitada: visita.empresa_visitada ?? visita.empresaVisitada,
            dataHoraPlanejada: visita.data_visita ?? visita.dataVisita ?? visita.data_hora_planejada,
            dataHoraReal:
              visita.data_hora_real ??
              visita.dataHoraReal ??
              visita.checkin_em ??
              linhaAtual?.checkin_em ??
              linhaAtual?.checkinEm ??
              null,
            checkinEm: visita.checkin_em ?? linhaAtual?.checkin_em ?? linhaAtual?.checkinEm ?? null,
            checkoutEm: visita.checkout_em ?? linhaAtual?.checkout_em ?? linhaAtual?.checkoutEm ?? null,
            checkoutRegistradoPorNome: visita.checkout_registrado_por_nome ?? visita.checkoutRegistradoPorNome ?? null,
            ehGrupo: visita.eh_grupo ?? visita.ehGrupo ?? false,
            quantidade: visita.quantidade ?? visita.quantidade_visitantes ?? 1,
            totalVisitantesNaSolicitacao: Number(totalNaSol) || 1,
          };
          this.statusVisita = Math.min(6, Math.max(1, visita.status ?? visita.status_visita ?? 4));
          this.visitaCancelada = Boolean(visita.cancelada);
          this.listaVisitantesDaVisita =
            listaApi.length > 0
              ? listaApi
              : [{ index: this.visitanteIndexChecklist, nome_completo: this.visitante.nome }];
          const qu = {};
          const rawQu = visita.qrcodes_usados_visitantes ?? visita.qrcodesUsadosVisitantes;
          if (Array.isArray(rawQu)) {
            rawQu.forEach((row) => {
              const ix = row.visitante_index ?? row.visitanteIndex;
              const qr = row.qr_code ?? row.qrCode;
              if (qr != null && ix != null && ix !== "") qu[Number(ix)] = qr;
            });
          }
          this.qrcodesUsadosPorVisitante = qu;
        }
      } catch (err) {
        try {
          const sol = await solicitacaoVisitaService.obterPorId(this.idVisita);
          if (sol) {
            this.resumoVisitaRestrita = {
              nomeAnfitriao: sol.nomeAnfitriao || "",
              statusAgendamento: sol.statusAgendamento ?? null,
            };
            this.aplicarFlagsTipoVisita(sol);
            const lista = sol.listaVisitantes || [];
            const vi = this.visitanteIndexChecklist;
            const ehGrupo = lista.length > 1;
            const linha = lista[vi];
            const nomeUm = linha
              ? (linha.nomeCompleto || linha.nome_completo || "").trim()
              : (sol.nomeCompleto || "");
            const nomes = lista.map((v) => v.nomeCompleto || v.nome_completo).filter(Boolean).join(", ");
            const listaSol = montarListaVisitantesSolicitacao(lista);
            const linhaSol = linhaVisitantePorIndex(listaSol, vi);
            this.visitante = {
              nome: nomeUm || (ehGrupo ? nomes : sol.nomeCompleto || ""),
              empresa: sol.empresaOrigem,
              empresaVisitada: "—",
              dataHoraPlanejada: sol.dataVisita ? `${sol.dataVisita}T${sol.horarioEntradaPrevisto || "08:00"}:00` : null,
              dataHoraReal: linhaSol?.checkin_em ?? linhaSol?.checkinEm ?? sol.checkinEm ?? null,
              checkinEm: linhaSol?.checkin_em ?? linhaSol?.checkinEm ?? sol.checkinEm ?? null,
              checkoutEm: linhaSol?.checkout_em ?? linhaSol?.checkoutEm ?? sol.checkoutEm ?? null,
              checkoutRegistradoPorNome: sol.checkoutRegistradoPorNome ?? null,
              ehGrupo,
              quantidade: lista.length || 1,
              totalVisitantesNaSolicitacao: lista.length || 1,
            };
            this.statusVisita = Math.min(6, Math.max(1, sol.statusAgendamento ?? 4));
            this.visitaCancelada = Boolean(sol.cancelada);
            this.listaVisitantesDaVisita =
              listaSol.length > 0
                ? listaSol
                : [{ index: 0, nome_completo: this.visitante.nome }];
            this.qrcodesUsadosPorVisitante = {};
          }
        } catch (e) {
          console.error(e);
        }
        if (!this.visitante.nome)
          this.visitante = { nome: "—", empresa: "—", empresaVisitada: "—", ehGrupo: false, quantidade: 1, totalVisitantesNaSolicitacao: 1 };
        if (!this.listaVisitantesDaVisita || this.listaVisitantesDaVisita.length === 0) {
          this.listaVisitantesDaVisita = [{ index: 0, nome_completo: this.visitante.nome }];
        }
      }
      if (this.idVisita) this.carregarQrCodes();
    },

    async carregarQrCodes() {
      if (!this.idVisita) return;
      try {
        const [lista, vinculacoes] = await Promise.all([
          checklistAcessoService.listarQrCodesFixos(),
          checklistAcessoService.obterVinculacoesVisita(this.idVisita),
        ]);
        this.qrCodesFixos = Array.isArray(lista) ? lista : [];
        const porVisitante = {};
        (vinculacoes || []).forEach((v) => {
          porVisitante[v.visitanteIndex] = v.qrCode;
        });
        this.vinculacoesPorVisitante = porVisitante;
      } catch (err) {
        console.error(err);
        this.qrCodesFixos = [];
        this.vinculacoesPorVisitante = {};
        toaster.show("Não foi possível carregar os QR codes. Verifique a conexão com a API.", { type: "error" });
      }
    },

    async vincularQrCodeAtual() {
      const iv = this.visitanteIndexChecklist;
      const qrCodeId = this.qrCodeSelecionadoPorVisitante[iv];
      if (!this.idVisita || qrCodeId == null || this.enviandoQrPorVisitante[iv]) return;
      this.enviandoQrPorVisitante = { ...this.enviandoQrPorVisitante, [iv]: true };
      try {
        await checklistAcessoService.vincularQrCode(this.idVisita, iv, qrCodeId);
        await this.carregarQrCodes();
        this.qrCodeSelecionadoPorVisitante = { ...this.qrCodeSelecionadoPorVisitante, [iv]: null };
        toaster.show("QR code vinculado ao visitante.", { type: "success" });
      } catch (err) {
        console.error(err);
        toaster.show(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Erro ao vincular QR code.",
          { type: "error" }
        );
      } finally {
        this.enviandoQrPorVisitante = { ...this.enviandoQrPorVisitante, [iv]: false };
      }
    },

    async desvincularQrCodeAtual() {
      const iv = this.visitanteIndexChecklist;
      if (!this.idVisita || this.enviandoQrPorVisitante[iv]) return;
      this.enviandoQrPorVisitante = { ...this.enviandoQrPorVisitante, [iv]: true };
      try {
        await checklistAcessoService.desvincularQrCode(this.idVisita, iv);
        await this.carregarQrCodes();
        toaster.show("QR code desvinculado.", { type: "success" });
      } catch (err) {
        console.error(err);
        toaster.show(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Erro ao desvincular QR code.",
          { type: "error" }
        );
      } finally {
        this.enviandoQrPorVisitante = { ...this.enviandoQrPorVisitante, [iv]: false };
      }
    },

    async confirmarCheckin() {
      if (!this.checkinCompleto || this.enviandoCheckin) return;
      this.enviandoCheckin = true;
      try {
        const u = sso.getUsuarioLogado?.() ?? {};
        const uid = u.id != null ? Number(u.id) : 0;
        const nome = String(u.nome ?? u.name ?? "").trim();
        const payload = {
          itens: this.checkin,
          observacoes: this.obsCheckin,
          visitante_index: this.visitanteIndexChecklist,
          ...(uid > 0 ? { usuario_logado_id: uid } : {}),
          ...(nome ? { checkin_responsavel_nome: nome } : {}),
        };
        if (this.idVisita) {
          await checklistAcessoService.confirmarCheckin(this.idVisita, payload);
        }
        await this.carregarVisita();
        toaster.show("Check-in confirmado.", { type: "success" });
        this.carregarQrCodes();
      } catch (err) {
        console.error(err);
        toaster.show("Não foi possível registrar a entrada.", { type: "error" });
      } finally {
        this.enviandoCheckin = false;
      }
    },

    async finalizarCheckout() {
      if (!this.checkoutCompleto || this.enviandoCheckout) return;
      this.enviandoCheckout = true;
      try {
        const u = sso.getUsuarioLogado?.() ?? {};
        const uid = u.id != null ? Number(u.id) : 0;
        const nome = String(u.nome ?? u.name ?? "").trim();
        const payload = {
          itens: this.checkout,
          observacoes: this.obsCheckout,
          visitante_index: this.visitanteIndexChecklist,
          usuario_logado_id: uid > 0 ? uid : undefined,
          checkout_responsavel_nome: nome || undefined,
        };
        if (this.idVisita) {
          await checklistAcessoService.finalizarCheckout(this.idVisita, payload);
        }
        await this.carregarVisita();
        if (this.statusVisita >= 6) {
          toaster.show("Todos os visitantes finalizaram. Visita encerrada.", { type: "success" });
          this.$router.push("/solicitacoes");
        } else {
          toaster.show("Saída deste visitante registrada.", { type: "success" });
        }
      } catch (err) {
        console.error(err);
        toaster.show("Não foi possível registrar a saída.", { type: "error" });
      } finally {
        this.enviandoCheckout = false;
      }
    },
  },
};
</script>
<style scoped>
.card-visitante {
  background: var(--cor-cinza);
  border-radius: 8px;
  padding: 1rem 1.5rem;
}

.card-visitante-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem;
}

.card-visitante-icone {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--cor-fonte-forte);
  color: var(--cor-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.card-visitante-dados {
  flex: 1;
  min-width: 200px;
}

.badge-grupo {
  font-size: 0.8rem;
  color: var(--cor-primaria-forte);
  margin-bottom: 0.25rem;
  font-weight: 600;
}

.card-visitante-dados .nome {
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.card-visitante-dados .linha {
  font-size: 0.9rem;
  color: var(--cor-fonte);
}

.card-visitante-dados .empresa-origem-linha {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.2rem;
}

.card-visitante-dados .empresa-edit {
  width: 100%;
  margin-top: 0.25rem;
}

.card-visitante-dados .empresa-edit-acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.card-visitante-dados .btn-alterar-empresa {
  margin-top: 0;
}

.card-visitante-acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.btn-acao {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: var(--cor-primaria);
  color: var(--cor-bg);
  border: none;
  border-radius: 24px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
}

.btn-acao:hover {
  opacity: 0.9;
  color: var(--cor-bg);
}

.btn-acao i {
  margin-right: 0.35rem;
}

.status-visita {
  background: var(--cor-fonte-fraca);
  color: var(--cor-bg);
  border-radius: 8px;
  padding: 1rem 1.5rem;
}

.status-titulo {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.timeline-visita {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.timeline-etapa {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.etapa-marker {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--cor-separador);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.timeline-etapa.concluido .etapa-marker {
  background: var(--cor-sucesso);
}

.timeline-etapa.atual .etapa-marker {
  background: var(--cor-primaria);
}

.etapa-icone {
  font-size: 0.8rem;
}

.etapa-label {
  font-size: 0.85rem;
  white-space: nowrap;
}

.etapa-seta {
  width: 12px;
  height: 2px;
  background: var(--cor-separador);
  margin: 0 4px;
}

.secao-qrcode-leitura {
  background: var(--cor-cinza);
  border-radius: 8px;
}

.grid-checklist {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

@media (max-width: 900px) {
  .grid-checklist {
    grid-template-columns: 1fr;
  }
}

.col-checklist {
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid var(--cor-separador);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.col-checklist.estado-acao {
  border-color: var(--cor-primaria);
  box-shadow: 0 0 0 1px var(--cor-primaria-fraca);
}

.col-checklist.estado-bloqueado {
  border-color: var(--cor-separador);
  opacity: 0.85;
}

.col-checklist.estado-concluido {
  border-color: var(--cor-sucesso);
  background: linear-gradient(to bottom, var(--cor-primaria-fraca) 0%, var(--cor-bg) 8rem);
}

.aba-titulo {
  padding: 0.9rem 1.25rem;
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--cor-bg);
}

.aba-titulo i {
  margin-right: 0.5rem;
}

.aba-entrada {
  background: var(--cor-primaria);
  color: var(--cor-bg);
}

.aba-saida {
  background: var(--cor-primaria-forte);
  color: var(--cor-bg);
}

.aba-bloqueado {
  background: var(--cor-fonte-fraca);
  color: var(--cor-bg);
}

.aba-concluido {
  background: var(--cor-sucesso);
  color: var(--cor-bg);
}

.checklist-body {
  padding: 1.25rem;
}

.item-checklist {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  font-size: 0.95rem;
}

.item-checklist input {
  margin-top: 0.2rem;
}

.campo-obs,
.campo-grupo {
  margin-top: 1rem;
}

.campo-obs label,
.campo-grupo label {
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.campo-obs textarea,
.campo-grupo input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--cor-separador);
  border-radius: 6px;
}

.checkout-auto-txt {
  margin: 0;
  line-height: 1.45;
}

.btn-acao-visita {
  margin-top: 1.25rem;
  padding: 0.7rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: transform 0.15s, box-shadow 0.15s;
}

.btn-acao-visita:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 0 0 1px var(--cor-separador);
}

.btn-acao-visita:disabled {
  cursor: not-allowed;
  transform: none;
}

.btn-acao-visita i {
  font-size: 1.1em;
}

.btn-acao-visita.btn-principal {
  background: var(--cor-primaria);
  color: var(--cor-bg);
}

.btn-acao-visita.btn-principal:hover:not(:disabled) {
  box-shadow: 0 0 0 1px var(--cor-primaria-media);
}

.btn-acao-visita.btn-secundario {
  background: var(--cor-cinza);
  color: var(--cor-fonte);
}

.btn-acao-visita.btn-concluido {
  background: var(--cor-sucesso);
  color: var(--cor-bg);
  opacity: 0.95;
}

.btn-acao-visita.btn-concluido:disabled {
  opacity: 0.9;
}

.btn-acao-visita.btn-bloqueado {
  background: var(--cor-fonte-fraca);
  color: var(--cor-fonte);
}

.aviso-aguarde {
  margin: 0 1rem 0.75rem;
  padding: 0.6rem 0.9rem;
  background: var(--cor-primaria-fraca);
  border-left: 4px solid var(--cor-primaria);
  border-radius: 6px;
  font-size: 0.9rem;
  color: var(--cor-primaria-forte);
}

.aviso-aguarde i {
  margin-right: 0.35rem;
}

.btn-link-acao {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.5rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--cor-primaria);
  text-decoration: underline;
}

.pendencias-checkin {
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: var(--cor-cinza);
  border: 1px solid var(--cor-separador);
}

.pendencias-lista {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
}

.card-dados-restrito {
  max-width: 720px;
  padding: 1.25rem 1.5rem;
  border: 1px solid var(--cor-separador);
  border-radius: 12px;
}

.lista-dados-restrita {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 0.35rem 1rem;
  margin: 0 0 1.25rem;
  font-size: 0.95rem;
}

.lista-dados-restrita dt {
  color: var(--cor-fonte-fraca);
  font-weight: 500;
}

.lista-dados-restrita dd {
  margin: 0;
}
</style>
